<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <div class="d-flex flex-row" style="width: 100%">
        <div style="width: 70%">
          <h1>{{ info.ownerName }}</h1>
          <br />
          <span class="text-muted" style="font-size: 16px">
            <b-icon icon="geo-alt-fill"></b-icon> {{ info.businessRegistrationAddress }}</span
          >
        </div>
        <div style="width: 30%" class="text-right">
          <button
            type="button"
            @click="ReturnToList"
            class="btn btn-outline-secondary hc-37 mr-2 pt-2"
          >
            <i class="bx bx-arrow-back"></i>
            <span>&nbsp;</span>Quay lại
          </button>
        </div>
      </div>
    </div>

    <b-card style="border-top: 1px solid #afb0b3">
      <b-row class="gx-2">
        <b-col cols="2" md="2" class="inner_menu">
          <MenuInner
            :activeItem="activeItem"
            :DetailMenus="DetailMenus"
            :id="id"
            :moName="info.ownerName"
          >
          </MenuInner>
        </b-col>
        <b-col cols="2" md="1">
          <template v-if="!isLoading">
            <div class="text-center">
              <img :src="info.logo" width="80" height="80" class="img_logo" />
            </div>
          </template>
          <template v-else>
            <div class="spinner-center">
              <b-spinner class="align-middle" />
            </div>
          </template>
        </b-col>
        <b-col cols="10" md="4">
          <DetailInfo :info="info" :isLoading="isLoading" :fields="keyNames">
            <!-- <template #id="{ value }">
              <strong>{{ value }}</strong>
            </template> -->
            <!-- <template #businessRegistration>
              {{ `${info.businessRegistrationAddress || ''} - ${getDisplayName(info.provinceCode)} -
              ${getDisplayName(info.districtCode)}` }}
            </template>
            <template #headquarters>
              {{ `${info.headquartersAddress || ''} - ${getDisplayName(info.headquartersProvinceCode)} -
              ${getDisplayName(info.headquartersDistrictCode)}`
              }}
            </template> -->
            <template #mainBusinessMcc="{ value }">
              {{ getBusinessTypeName(value) }}
            </template>
            <template #ownershipType="{ value }">
              {{ getOwnershipTypeNAme(value) }}
            </template>
          </DetailInfo>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Trạng thái</strong>
              <span class="float-right"
                ><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span
              >
            </h1>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Hoạt động:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      <b-badge :variant="`${getStatusClass(info.mcStatus)}`">{{
                        getStatusName(info.mcStatus)
                      }}</b-badge>
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Ngày đồng bộ:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      <b-icon icon="arrow-repeat" class="mr-2"></b-icon>
                      {{ info.lastSyncAt | formatDate('HH:mm') }},
                      {{ info.lastSyncAt | formatDate }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Xác thực:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      <b-badge :variant="`${getAuthStatusClass(info.authStatus)}`">{{
                        getAuthStatusName(info.authStatus)
                      }}</b-badge>
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
        <b-col cols="10" md="4">
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin người đại diện</strong>
              <span class="float-right"
                ><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span
              >
            </h1>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Địa chỉ theo ĐKKD:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.businessRegistrationAddress }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Địa chỉ văn phòng hoạt động:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.headquartersAddress }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Số điện thoại:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.mobile }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Email:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.email }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Website:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.website }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
          <div class="form-detail">
            <h1>
              <strong class="h1-strong">Thông tin khác</strong>
              <span class="float-right"
                ><b-button variant="outline-primary" class="btn-class">Sửa</b-button></span
              >
            </h1>
            <template v-if="!isLoading">
              <div class="form-group form-row">
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Nguồn:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.referSource }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Vùng kinh doanh:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.headquartersAddress }}
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 border-row">
                  <label for="" class="col-sm-4 col-form-label">
                    <span class="float-left">Nhân viên phát triển:</span>
                  </label>
                  <div class="col-sm-8">
                    <p>
                      {{ info.saleStaffName }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </template>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Detail } from '@/services/customer-support/merchant-owner'
  import { showMess } from '@/config/utils'
  // import ListContract from './components/ListContract'
  // import ListStore from './components/ListStore'
  // import ListStoreStaff from './components/ListStoreStaff'
  // import ListMerchantAccounts from './components/ListMerchantAccounts'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import { CommonService } from '@/services/common.service'
  import Config from '@/thirdParty/config'
  import { Search as SearchMA } from '@/services/customer-support/account'
  import { level3LocationDetails } from '@/config/manhthdConfigs' // level2LocationDetails
  import moment from 'moment'
  import MenuInner from '@/pages/customer-support/cskh/merchant-owner/components/MenuInner'
  import { StaffService } from '@/services/staff.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  export default {
    components: {
      // ListContract,
      // ListStore,
      // ListMerchantAccounts,
      // ListStoreStaff,
      DetailInfo,
      MenuInner,
    },
    data() {
      return {
        isLoading: false,
        isLoadingContract: false,
        id: '',
        info: {},
        maId: '',
        accountName: '',
        keyNames: [
          // { key: 'id', label: 'ID' },
          { key: 'masterName', label: 'Tên thương hiệu' },
          { key: 'ownerName', label: 'Tên đơn vị sở hữu' },
          { key: 'taxCode', label: 'Mã số thuế' },
          { key: 'businessRegistrationNumber', label: 'Số giấy ĐKKD' },
          // { key: 'mobile', label: 'Số điện thoại' },
          // { key: 'email', label: 'Email' },
          // { key: 'website', label: 'Website' },
          { key: 'ownershipType', label: 'Loại hình sở hữu' },
          { key: 'mainBusinessMcc', label: 'Ngành nghề' },
          { key: 'detailedBusinessMcc', label: 'Ngành nghề KD chi tiết' },
          // { key: 'businessRegistration', label: 'Địa chỉ ĐKKD' },
          // { key: 'businessRegistrationAddress', label: 'Địa chỉ theo ĐKKD' },
          // { key: 'headquartersAddress', label: 'Địa chỉ văn phòng hoạt động' },
          // { key: 'headquarters', label: 'Trụ sở chính' },
          // { key: 'logo', label: 'Logo thương hiệu' },
          // { key: 'mcStatus', label: 'Trạng thái hoạt động' },
          // { key: 'authStatus', label: 'Trạng thái xác thực' },
          // { key: 'syncStatus', label: 'Trạng thái cập nhật/ đồng bộ dữ liệu' },
          // { key: 'lastSyncAt', label: 'Thời gian cuối cập nhật/ đồng bộ dữ liệu' },
          // { key: 'refCustomerId', label: 'Nguồn lấy từ MPOS/MY_NEXTPAY' },
          // { key: 'urlBusResgistrationNumber', label: 'Link ảnh ĐK KD' },
          // { key: 'regionCode', label: 'Mã vùng kinh doanh' },
          // { key: 'saleStaffId', label: 'Mã nhân viên' }
        ],
        dataConfigService: [],
        dataConfigMcc: [],
        ownershipType: [],
        listState: Config.listStatusMC,
        listStatus: [
          { id: 0, text: 'Tất cả' },
          { id: 'ACTIVE', text: 'Đang hoạt động', bgColor: 'primary' },
          { id: 'PENDING_CONFIRM_APPROVAL', text: 'Chờ duyệt', bgColor: 'danger' },
          { id: 'SUSPENDED', text: 'Bị khoá', bgColor: 'danger' },
          { id: 'UNDEFINED', text: 'Không xác định', bgColor: 'secondary' },
        ],
        listAuthStatus: [
          { id: 'NOT_AUTHENTICATED', text: 'Chưa xác thực', bgColor: 'warning' },
          { id: 'AUTHENTICATED', text: 'Đã xác thực', bgColor: 'success' },
        ],
        DetailMenus: [
          {
            id: 'thong_tin_chung',
            label: 'Thông tin chung',
            icon: 'person-lines-fill',
            link: '/customer-support/merchant-owner/{id}',
          },
          // { id: 'lich_su_gan', label: 'Lịch sử gán NV', icon: 'list-check', link: '/customer-support/account/{id}/history-assign' },
          {
            id: 'list_store',
            label: 'Danh sách cửa hàng',
            icon: 'shop',
            link: '/customer-support/store/?moId={moId}&moName={moName}',
          },
          {
            id: 'list_merchant',
            label: 'Danh sách Merchant Accountt',
            icon: 'person-fill',
            link: '/customer-support/account/?moId={moId}&moName={moName}',
          },
          {
            id: 'list_task',
            label: 'Danh sách công việc',
            icon: 'list-task',
            link: '/customer-support/task/?moId={moId}&moName={moName}',
          },
          {
            id: 'list_contact',
            label: 'Danh sách liên hệ',
            icon: 'phone',
            link: '/customer-support/contact/?moId={moId}&moName={moName}',
          },
        ],
        activeItem: 'thong_tin_chung',
      }
    },

    filters: {},

    created() {
      this.id = this.$router.currentRoute.params.id
    },

    async mounted() {
      if (this.dataPermission.includes('CNPS_CSS_MO_DETAIL')) {
        await this.loadData()
        await this.toggleSideBar()
        this.configSystem()
        await this.getRegions()
        await this.getManager()
        await this.getListStaffBySuperior()
        await this.getMcRegions()
        await this.getMcDistrict()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },

      getAuthStatusName() {
        return status => {
          const objStatus = this.listAuthStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getAuthStatusClass() {
        return status => {
          const objStatus = this.listAuthStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getBusinessTypeName() {
        return mcc => {
          const objStatus = this.dataConfigMcc.find(s => s.id === mcc)
          return objStatus ? objStatus.text : mcc
        }
      },
      getOwnershipTypeNAme() {
        return ownertShipType => {
          const objStatus = this.ownershipType.find(s => s.id === ownertShipType)
          return objStatus ? objStatus.text : ownertShipType
        }
      },
    },

    methods: {
      ReturnToList() {
        this.$router.push(`/customer-support/merchant-owner`)
      },
      setActive(id) {
        this.activeItem = id
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)
          this.info = res.data
          // this.getMaInfo();
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      async getMaInfo() {
        const searchQuery = {
          limit: 1,
          page: 1,
          queryString: `{textSearch} LIKE '''${this.info.email}'''`,
          sort: {
            direction: 'DESC',
            properties: ['createdDate'],
          },
        }
        const res = await SearchMA(searchQuery)
        if (res.data?.listData) {
          const dataMa = res.data.listData[0]
          this.maId = dataMa.id
          this.accountName = dataMa.accountName
        }
      },
      formatDate(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },

      formatHour(date) {
        if (!date) return
        return moment(date).format('HH:mm')
      },
      // getDisplayName(key) {
      //   let nameObj;
      //   const provinceCodeName = level2LocationDetails.find(loca => loca.code === key)
      //   const districtCodeName = level3LocationDetails.find(loca => loca.code === key)
      //   const statusName = this.listStatus.find(status => status.id === key);
      //   const authStatusName = this.listAuthStatus.find(authStatus => authStatus.id === key);
      //   if (statusName) {
      //     nameObj = statusName.text;
      //   }
      //   if (authStatusName) {
      //     nameObj = authStatusName.text;
      //   }
      //   if (provinceCodeName) {
      //     nameObj = provinceCodeName.name;
      //   }
      //   if (districtCodeName) {
      //     nameObj = districtCodeName.name;
      //   }
      //   return nameObj ?? key;
      // },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: 0, text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.businessProvinceCode = ''
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegionMC.unshift({ id: 0, text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        try {
          this.filters.provinceCode = ''
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy quận mc
      async getMcDistrict() {
        this.dataDistrict = level3LocationDetails.map(e => {
          return {
            id: e.code,
            text: e.name,
          }
        })
        this.dataDistrict.unshift({ id: 0, text: 'Tất cả' })
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lấy quản lý
      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.dataManager.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.ownershipType = data.data.ownershipType.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
              this.dataConfigService = data.data.services.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.getListService()
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              this.dataConfigService = data[0].detail.map(e => {
                return {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
              })
            }
            // ListState
            this.listStateSearch = [{ id: 0, text: 'Tất cả' }, ...this.listState]
          }
        } catch (error) {
          console.log(error)
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
  }
</script>

<style scoped>
  .breadcrumb {
    margin-bottom: 0;
  }

  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  ul.report-preview {
    padding-left: 0;
    display: flex;

    li {
      border: 1px solid #ddd;
      border-radius: 5px;
      width: 100px;
      min-width: 100px;
      height: 60px;
      cursor: pointer;
      /* text-align: center; */
      padding: 10px;

      &:hover {
        color: #f00;
        font-weight: 500;
      }

      .label {
        font-size: 14px;
        text-align: center;
      }

      .value {
        text-align: center;
        margin-top: 2px;
        font-size: 16px;
        font-weight: 600;
      }

      & + li {
        margin-left: 10px;
      }
    }
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid darkblue;
    padding-left: 5px;
    font-size: larger;
  }

  .img_logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #ddd;
  }

  .btn-class {
    background-color: #edf6ff;
  }

  .btn-class:hover {
    background-color: #007bff;
  }

  .inner_menu {
    border-right: 1px solid #afb0b3;
  }

  .menu_li:hover {
    background-color: #268dfc;
    color: #fff;
    cursor: pointer;
  }

  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }
</style>
